<template>
  <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 745 880" class="pointer-events-none">
    <defs>
      <symbol id="Cursor" data-name="Cursor" viewBox="0 0 103.071 35.127">
        <path class="cls-1" d="M101.071,0h-92a2,2,0,0,0-2,2V8.929L0,16l7.071,7.071V30a2,2,0,0,0,2,2h92a2,2,0,0,0,2-2V2A2,2,0,0,0,101.071,0Z" />
        <text class="cls-3" transform="translate(42.0712 11.9995)">CURRENT</text>
        <text class="cls-4" transform="translate(41.0712 26.9995)">FLOOR</text>
        <path class="cls-8" d="M34.071,16a1.2029,1.2029,0,0,1-.1088.4561,9.9016,9.9016,0,0,1-17.7823,0,1.01,1.01,0,0,1,0-.9122,9.9016,9.9016,0,0,1,17.7823,0A1.1984,1.1984,0,0,1,34.071,16Zm-1,0a10.7758,10.7758,0,0,0-4.0556-4.042,5,5,0,1,1-7.8887,0A10.7768,10.7768,0,0,0,17.071,16a8.9,8.9,0,0,0,16,0Zm-12-1a4,4,0,1,0,4-4A4.0015,4.0015,0,0,0,21.071,15Zm2,0c0-.03.0093-.0576.0093-.0889A1.7828,1.7828,0,0,0,23.5867,15a1.4849,1.4849,0,0,0,1.4843-1.4844,1.7889,1.7889,0,0,0-.0888-.5068c.03-.001.0576-.0088.0888-.0088a2,2,0,1,1-2,2Z" />
      </symbol>
    </defs>

    <g>
      <image width="745" height="880" xlink:href="images/hatyai_condo_tower@2x.png" class="pointer-events-none" />
      <use v-if="translate" width="103.071" height="35.1274" :transform="translate" class="transition-all duration-500 pointer-events-auto" xlink:href="#Cursor" @click="openPano(floor.name)" />
    </g>

  </svg>
</template>

<script>
export default {
  name: 'FloorTower',
  props: {
    floor: {
      type: Object,
      required: true,
    },
  },
  emits: ['show'],
  data () {
    return {
      positions: [
        { floor: '06', x: 533.9295, y: 464.4778 },
        { floor: '07', x: 533.9295, y: 450.276 },
        { floor: '08', x: 533.9295, y: 436.0742 },
        { floor: '09', x: 533.9295, y: 421.8723 },
        { floor: '10', x: 533.9295, y: 407.6705 },
        { floor: '11', x: 533.9295, y: 393.4686 },
        { floor: '12', x: 533.9295, y: 379.2668 },
        { floor: '12A', x: 533.9295, y: 365.065 },
        { floor: '14', x: 533.9295, y: 350.8631 },
        { floor: '15', x: 533.9295, y: 336.6613 },
        { floor: '16', x: 533.9295, y: 322.4595 },
        { floor: '17', x: 533.9295, y: 308.2576 },
        { floor: '18', x: 533.9295, y: 294.0558 },
        { floor: '19', x: 533.9295, y: 279.854 },
        { floor: '20', x: 533.9295, y: 265.6521 },
        { floor: '21', x: 533.9295, y: 251.4503 },
        { floor: '22', x: 533.9295, y: 237.2485 },
        { floor: '23', x: 533.9295, y: 223.0466 },
        { floor: '24', x: 533.9295, y: 208.8448 },
        { floor: '25', x: 533.9295, y: 194.643 },
        { floor: '26', x: 533.9295, y: 180.4411 },
        { floor: '27', x: 533.9295, y: 166.2393 },
        { floor: '28', x: 533.9295, y: 152.0375 },
        { floor: '29', x: 533.9295, y: 137.8356 },
        { floor: '30', x: 533.9295, y: 123.6338 },
        { floor: '31', x: 533.9295, y: 109.432 },
        { floor: '32', x: 533.9295, y: 95.2301 },
        { floor: '33', x: 533.9295, y: 81.0283 },
        { floor: '34', x: 533.9295, y: 66.8264 },
        { floor: '35', x: 533.9295, y: 28.4679 },
        { floor: '36', x: 533.9295, y: 14.266 },
      ],
    }
  },
  computed: {
    translate () {
      const pos = this.positions.find(({ floor }) => floor === this.floor.name)
      return pos ? `translate(${pos.x} ${pos.y})` : null
    },
  },
  methods: {
    onClick (e) {
      const el = e.target.closest('[data-name]')

      if (el) {
        this.$router.push('/vr-tour')
      }
    },
    openPano (floor) {
      const nodes = [
        {
          nodeId: 'node1',
          floors: ['31', '32', '33', '34', '35', '36'],
        },
        {
          nodeId: 'node2',
          floors: ['26', '27', '28', '29', '30'],
        },
        {
          nodeId: 'node3',
          floors: ['22', '23', '24', '25'],
        },
        {
          nodeId: 'node4',
          floors: ['18', '19', '20', '21'],
        },
        {
          nodeId: 'node5',
          floors: ['14', '15', '16', '17'],
        },
        {
          nodeId: 'node6',
          floors: ['10', '11', '12', '12A'],
        },
        {
          nodeId: 'node7',
          floors: ['06', '07', '08', '09'],
        },
      ]

      const { nodeId } = nodes.find(n => n.floors.includes(floor))

      this.$emit('show', nodeId)
    },
  },
}
</script>

<style>
.cls-1 {
  fill: #131313;
}

.cls-2,
.cls-3,
.cls-4 {
  isolation: isolate;
}

.cls-3 {
  font-size: 10px;
  font-family: CPN;
}

.cls-3,
.cls-4,
.cls-8 {
  fill: #fff;
}

.cls-4 {
  font-size: 16px;
  font-family: CPN;
  font-weight: 700;
}

.cls-5 {
  letter-spacing: -0.02em;
}

.cls-6 {
  letter-spacing: 0.01em;
}

.cls-7 {
  letter-spacing: 0em;
}
</style>
